/**
 * FAIR monogram path (Header asset) — used by page-loader draw animation.
 */
export const FAIR_PAGE_LOADER_MONOGRAM_PATH =
  'M38.6796 31.524L40.9065 31.4966C45.5367 31.3362 47.8797 29.4429 47.8797 25.6014C47.8797 21.3609 45.096 19.6534 40.2036 19.6534H9.61752V37.8437H13.1815V30.7495H21.0102V37.8437H24.5849V31.6551H34.6943L42.8992 37.8437H47.4692L40.4659 32.6428L38.6796 31.524ZM21.0102 28.1364H13.1815V22.4563H21.0102V28.1364ZM24.5849 29.1515V22.4563H39.9672C42.9851 22.4563 44.2168 23.3892 44.2168 25.8166C44.2168 28.2439 42.9873 29.1515 39.9672 29.1515H24.5849Z'

/** Route overlay: looping draw → fill → fade. */
export const FAIR_PAGE_LOADER_DRAW_MS = 2400

/**
 * Inline / products loader (`motion="spin"`):
 * short snake segment crawls along FR contour (pathLength=1).
 */
export const FAIR_PAGE_LOADER_SPIN_INTRO_MS = 160
/** One full lap of the snake around the monogram path. */
export const FAIR_PAGE_LOADER_FILL_MS = 2000
/** Visible snake length as fraction of normalized path (0–1). */
export const FAIR_PAGE_LOADER_SNAKE_RATIO = 0.14

/** Default size for inline product-grid loading. */
export const FAIR_PAGE_LOADER_INLINE_SIZE = 72

/** Min visible time so fast navigations do not flash. */
export const FAIR_PAGE_LOADER_MIN_MS = 500

/** Hard cap — never stick if a page forgets `markReady`. */
export const FAIR_PAGE_LOADER_MAX_MS = 5000

/**
 * Grace window after every readiness gate reports in (FE-003.1). Sections below the
 * fold mount a tick or two after the page shell, so a gate registered late must be
 * able to re-arm the overlay before it starts fading. Dismissal is additionally held
 * to the next painted frame.
 */
export const FAIR_PAGE_LOADER_SETTLE_MS = 120

export const FAIR_PAGE_LOADER_FADE_MS = 280

export type FairPageLoaderMotion = 'draw' | 'spin'
